import { IAlarmsFlexidas } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';
import { TEmptyObject } from '@interfaces/common/common';

import { EVendorsValues } from '@enums/common';

import { useQueryAlarmsListFlexidas } from './useQueryAlarmsListFlexidas';
import { useQueryAlarmsListLimenet } from './useQueryAlarmsListLimenet';
import { useQueryAlarmsListOran } from './useQueryAlarmsListOran';

interface IUseQueryAlarmsReturn {
	isLoadingTable: boolean;
	alarmList: IAlarmsFlexidas[];
	countOfRecords: number;
}

interface AlarmData<T = any> {
	isLoading: boolean;
	data: T[];
	countOfRecords: number;
}

const getAlarmsList = ({
	flexidas,
	limenet,
	oran,
	vendor,
}: {
	flexidas: AlarmData;
	limenet: AlarmData;
	oran: AlarmData;
	vendor: string;
}): TEmptyObject | AlarmData => {
	switch (vendor) {
		case EVendorsValues.flexidas:
			return flexidas;
		case EVendorsValues.limenet:
			return limenet;
		case EVendorsValues.oran:
			return oran;
		default:
			return {};
	}
};

export const useQueryAlarmsList = (params: IAlarmByVendor): IUseQueryAlarmsReturn => {
	const flexidas = useQueryAlarmsListFlexidas(params);
	const limenet = useQueryAlarmsListLimenet(params);
	const oran = useQueryAlarmsListOran(params);

	const {
		data = [],
		isLoading = false,
		countOfRecords = 0,
	} = getAlarmsList({
		flexidas,
		limenet,
		oran,
		vendor: params.vendor,
	}) || {};

	return {
		isLoadingTable: isLoading,
		alarmList: data,
		countOfRecords: countOfRecords,
	};
};
